// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"95cea8079d7e7dea9145","223":"484ce582a49cb5b7b5c6","691":"f7565a48601d3dbd5e38","843":"bbd42b1d17b9799eec72"}[chunkId] + ".js";
};